import { Component, Input, OnInit, inject } from '@angular/core';
import { AppService } from '../../../_services/app.service';

@Component({
  selector: 'manager-loader-wrapper-offcanvas',
  templateUrl: './loader_wrapper_offcanvas.component.html',
  standalone: false,
})
export class LoaderWrapperOffcanvasComponent {
  appS = inject(AppService);

  @Input() type: string;
  @Input() wrapper: string;
  //
  @Input() header: boolean;
}
